import AdsAssistant, { type AssistantPlatformConfig } from "@/components/AdsAssistant";

export type { ProposedAction } from "@/components/AdsAssistant";

const GOOGLE_ADS_ASSISTANT: AssistantPlatformConfig = {
  apiBase: "/admin/google-ads/ai",
  title: "Asistente de Google Ads",
  platformLabel: "Google Ads",
  storageKey: "rm_google_ads_ai_chat",
  suggestions: [
    "¿Cómo van las campañas en los últimos 14 días frente a los 14 anteriores?",
    "Revisa los términos de búsqueda y propón negativas para quitar tráfico de consumidores finales.",
    "¿Qué palabras clave gastan sin traer registros? ¿Cuáles pausarías?",
    "Revisa los textos de los anuncios y dime cómo mejorarlos para dueños de restaurantes.",
  ],
};

export default function GoogleAdsAssistant(props: {
  draft?: string | null;
  onDraftConsumed?: () => void;
  onApplied?: () => void;
}) {
  return <AdsAssistant config={GOOGLE_ADS_ASSISTANT} {...props} />;
}
